// Parse explicit dates without allowing Date.parse to guess a year.
export function receiptDateKey(value) {
  if (typeof value !== "string") return null;
  const match = value
    .trim()
    .match(
      /^(\d{4})([-/.])(\d{1,2})\2(\d{1,2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d{1,3})?)?(Z|[+-]\d{2}:?\d{2})?)?$/
    );
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[3]);
  const day = Number(match[4]);
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (year < 1 || month < 1 || month > 12 || day < 1 || day > days[month - 1])
    return null;
  if (
    Number(match[5] || 0) > 23 ||
    Number(match[6] || 0) > 59 ||
    Number(match[7] || 0) > 59
  )
    return null;
  if (match[8] && match[8] !== "Z") {
    const offset = match[8].slice(1).replace(":", "");
    if (Number(offset.slice(0, 2)) > 23 || Number(offset.slice(2)) > 59)
      return null;
  }
  // Date-level ordering: equal receipt dates retain the incoming order.
  return year * 10000 + month * 100 + day;
}

function shortReceiptDateKey(value, range) {
  if (typeof value !== "string") return null;
  const match = value.trim().match(/^(\d{1,2})([-/.])(\d{1,2})$/);
  const start = range?.start?.match(/^(\d{4})-(\d{2})$/);
  const end = range?.end?.match(/^(\d{4})-(\d{2})$/);
  if (!match || !start || !end || range.start > range.end) return null;
  const firstYear = Number(start[1]);
  const lastYear = Number(end[1]);
  const month = Number(match[1]);
  const day = Number(match[3]);
  // A same-year query supplies the year omitted by the sheet's M/D format.
  if (firstYear === lastYear)
    return receiptDateKey(`${firstYear}-${month}-${day}`);
  let candidate = null;
  for (let year = firstYear; year <= lastYear; year += 1) {
    const yearMonth = `${String(year).padStart(4, "0")}-${String(
      month
    ).padStart(2, "0")}`;
    if (yearMonth < range.start || yearMonth > range.end) continue;
    const key = receiptDateKey(`${year}-${month}-${day}`);
    if (key === null) continue;
    if (candidate !== null) return null; // More than one possible year.
    candidate = key;
  }
  return candidate;
}

export function originalReceiptDateKey(raw, range) {
  for (const field of ["접수일", "접수일자"]) {
    const key = receiptDateKey(raw?.[field]);
    if (key !== null) return key;
  }
  for (const field of ["접수일", "접수일자"]) {
    const key = shortReceiptDateKey(raw?.[field], range);
    if (key !== null) return key;
  }
  return null;
}

export function sortByReceiptDate(rows, range) {
  return rows
    .map((row, index) => ({
      row,
      index,
      date: originalReceiptDateKey(row.raw, range)
    }))
    .sort((a, b) => {
      if (a.date === null && b.date !== null) return 1;
      if (a.date !== null && b.date === null) return -1;
      return (b.date ?? 0) - (a.date ?? 0) || a.index - b.index;
    })
    .map(({ row }) => row);
}
